export default {
  root: {
    height: '22px',
    width: '22px',
    fontSize: '22px',
  },
}
